import React, { useState } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TablePagination, TextField, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import { Edit, Delete, Visibility, Add } from "@mui/icons-material";

const usersData = [
  { id: 1, name: "John Doe", email: "john@example.com", cnic: "-", role: "Admin" },
  { id: 2, name: "Sarah Smith", email: "sarah@example.com",cnic: "-", role: "User" },
  { id: 3, name: "Mike Johnson", email: "mike@example.com", cnic: "-",role: "Editor" },
  { id: 4, name: "Emma Brown", email: "emma@example.com", cnic: "-", role: "User" },
];

const generatePassword = () => {
  return Math.random().toString(36).slice(-8);
};

const UserTable = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(generatePassword());

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpen = () => {
    setPassword(generatePassword());
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };

  const filteredUsers = usersData.filter(user =>
    user.name.toLowerCase().includes(search.toLowerCase()) ||
    user.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", padding: 2 }}>
      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: "#4caf50" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Email</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Role</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>CNIC</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.role}</TableCell>
                <TableCell>{user.cnic}</TableCell>
                <TableCell>
                  {/* <IconButton color="primary"><Visibility /></IconButton>
                  <IconButton color="success"><Edit /></IconButton> */}
                  <IconButton color="error"><Delete /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredUsers.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      
      {/* Add New User Modal */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add New User</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Password"
            type="text"
            fullWidth
            variant="outlined"
            value={password}
            disabled
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" sx={{ backgroundColor: "#4caf50", color: "white" }}>Add</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default UserTable;
